import gsap from "gsap";
import {
  BoxGeometry,
  Color,
  CylinderGeometry,
  DoubleSide,
  Euler,
  Mesh,
  MeshBasicMaterial,
  MeshLambertMaterial,
  PlaneGeometry,
  Quaternion,
  Sprite,
  SpriteMaterial,
  TextureLoader,
  Vector3
} from 'three';

// import {Math} from 'three';
Math.degToRad = function(degrees) {
  var pi = Math.PI;
  return degrees * (pi / 180);
};

const getRandomNum = (max = 0, min = 0) =>
    Math.floor(Math.random() * (max + 1 - min)) + min;

export default class Creature {
  constructor() {

    const map = new TextureLoader().load(
        '/haiku-visualization/assets/images/sprite-03.png');
    const material = new SpriteMaterial(
        {map : map, transparent : true, opacity : 0, depthWrite : false});
    this.mesh = new Sprite(material);
    this.position = new Vector3();
    this.mesh.position.copy(this.position);
    this.mesh.scale.set(.15, .15, .15);
    this.velocity = new Vector3();
    this.velocity.multiplyScalar(.001);
    this.acceleration = new Vector3();
    this.wonderTheta = 0;
    this.maxSpeed = 4; // thi.params.maxSpeed;
    this.boost = new Vector3();
    this.friction = .999;
    this.target = new Vector3();
    this.opos = new Vector3();
    this.tweens = [];
  }

  reset() {
    const radius = getRandomNum(.1, 1);
    const theta = Math.degToRad(getRandomNum(180));
    const phi = Math.degToRad(getRandomNum(360));
    this.position.x = Math.sin(theta) * Math.cos(phi) * radius * 4;
    this.position.y = Math.sin(theta) * Math.sin(phi) * radius;
    this.position.z = Math.cos(theta) * radius - 4.0;
    this.mesh.position.copy(this.position);
    this.mesh.scale.set(.10, .10, .10);

    this.velocity.x = (Math.random() - .5) * 0.01;
    this.velocity.y = (Math.random()) * 0.01;
    this.velocity.z = -(Math.random() - .5) * 0.001;
    this.velocity.normalize();
    this.velocity.multiplyScalar(.0025);

    // this.velocity.set(Math.random() - .5, Math.random() * .5,
    //                   -Math.random() - .5);
    // this.velocity.multiplyScalar(.001);
    this.acceleration.set(0, 0, 0);
    this.wonderTheta = 0;
    this.maxSpeed = 4;
  }

  applyForce(f) { this.acceleration.add(f.clone()); }

  update() {
    // const maxSpeed = this.maxSpeed;

    // boost
    this.applyForce(this.boost);
    this.boost.multiplyScalar(0.8);
    if (this.boost.length() < 0.01) {
      this.boost = new Vector3();
    }

    // update velocity
    this.velocity.add(this.acceleration);

    // limit velocity
    // if (this.velocity.length() > maxSpeed) {
    //   this.velocity.clampLength(0, maxSpeed);
    // }

    this.velocity.multiplyScalar(this.friction);

    // update position
    this.position.add(this.velocity);
    this.mesh.position.copy(this.position);

    // reset acc
    this.acceleration.multiplyScalar(0);

    // head
    // const head = this.velocity.clone();
    // head.multiplyScalar(10);
    // head.add(this.position);
    // this.mesh.lookAt(head);
    // this.mesh.rotation.y = -Math.PI / 2;
  }
}
